var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"banner"},[_c('div',{staticClass:"m"},[_c('el-row',{attrs:{"gutter":20}},[_c('el-col',{attrs:{"span":24}},[_c('Carousel',{attrs:{"height":"530px"}})],1)],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }